//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import scholingseditiePost from '~/graphql/queries/scholingseditiePost.gql';
import deleteScholingseditiePost from '~/graphql/mutations/deleteScholingseditiePost.gql';
import publishScholingseditiePost from '~/graphql/mutations/publishScholingseditiePost.gql';

export default {
  auth: false,
  apollo: {
    scholingseditiePost: {
      query: scholingseditiePost,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
    },
  },
  data: () => ({
    scholingseditiePost: {},
    userUuid: false,
    isAdmin: false,
    placeholderImage: require('~/assets/img/post_placeholder.png'),
  }),
  mounted() {
    this.userUuid = this.$auth.loggedIn ? this.$auth.user.uuid : null;
    this.isAdmin = this.$auth.loggedIn ? this.$auth.user.is_admin : false;
  },
  methods: {
    async deletePost() {
      if (confirm('Weet je zeker dat je deze bericht wilt verwijderen?')) {
        try {
          await this.$apollo.mutate({
            mutation: deleteScholingseditiePost,
            variables: {
              slug: this.$route.params.slug,
            },
          }).then(() => {
            this.$toast.success('Het bericht is verwijderd.');
            this.$router.push({name: 'opleiding-training-en-boekrecensies'});
          });
        } catch (e) {
          this.$toast.error(e);
        }
      }
    },
    async publishPost() {
      if (confirm('Weet je zeker dat je deze bericht wilt gaan publiceren?')) {
        try {
          await this.$apollo.mutate({
            mutation: publishScholingseditiePost,
            variables: {
              slug: this.$route.params.slug,
            },
            refetchQueries: [{
              query: scholingseditiePost,
              fetchPolicy: 'network-only',
              variables: {slug: this.$route.params.slug},
            }],
          }).then(() => {
            this.$toast.success('Het bericht is gepubliceerd.');
          });
        } catch (e) {
          this.$toast.error(e);
        }
      }
    },
  },
};
